//
// Copyright (c) 2011-2024 by Curalate, Inc
//

import React from 'react';
import styled from 'styled-components';

import {
  BodyBoldText,
  BodyText,
  LinkPrimaryText,
} from '@components/atoms/text/Text';

export const EmptyLabels = () => (
  <Wrapper>
    <BodyBoldText>No labels available for this media.</BodyBoldText>
    <BodyText>
      Add labels to media to organize your library or to filter media in your
      touch points.
    </BodyText>
    <LinkPrimaryText>
      <a
        href='https://support.bazaarvoice.com/s/article/Labels-Overview?language=en_US'
        target='_blank'
        rel='noreferrer'
      >
        Learn more
      </a>
    </LinkPrimaryText>
  </Wrapper>
);

const Wrapper = styled.div`
  max-width: 100%;
`;
